import {
    Button,
    Grid,
} from '@mui/material';
import './Example.css';
import DownloadIcon from '@mui/icons-material/Download';
import { Link } from 'react-router-dom';
import PageHeader from '../includes/PageHeader';
import { ROUTES_LIST } from '../../../helpers/routesList';
export function Example() {
    const handleDownload = () => {
        const fileUrl = '/file/example.xlsx';
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'example.xlsx'); 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="wrapper">
        <PageHeader title="Download Example Excel" />
        <Grid container direction="column" alignItems="center" spacing={3}>
            <Grid item>
                <p>Доорх товч дээр дарж жишээ файлыг татна уу.</p>
            </Grid>
            <Grid item>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<DownloadIcon />} 
                    onClick={handleDownload}
                >
                    Download Excel Example
                </Button>
            </Grid>
            <Grid item>
                <Link to={ROUTES_LIST.epgPage}>Хөтөлбөр оруулах хэсэгрүү буцах</Link>
            </Grid>
        </Grid>
        </div>
    );
}
